import React, { useState, useEffect } from "react";

import AbhimanuKumar from "../../assets/images/people/AbhimanuKumar.webp";
import JeetuMahtani from "../../assets/images/people/JeetuMahtani.webp";
import BrianBohus from "../../assets/images/people/Brian_Bohus.webp";
import AlokRanjan from "../../assets/images/people/Alok Ranjan.webp";
import VagelisPapalexakis from "../../assets/images/people/Vagelis Papalexakis.webp";
import KieranFlanagan from "../../assets/images/people/Kieran_Flanagan.webp";
import JohnKelleher from "../../assets/images/people/John_Kelleher.webp"
import linkedin from "../../assets/images/icons/linkedin-mini.svg";
import openPopup from "../../assets/images/icons/open-popup.svg";
import closeIcon from "../../assets/images/icons/circle-xmark-closed.svg";
const OurTeams = () => {
  return (
    <div>
      <div className="container">
        <div className="section-heading my-5 ">
          <h2 className="newsLatest-title text-center world-class-heading">
            World Class Team
          </h2>
          <p className="text-center world-class-subheading">
            Our team includes experts in AI/ML, Data Science, SEO, B2B products
            and eCommerce.
          </p>
        </div>
        <div className="teams-container">
          <TeamMember data={MemberList.ONE} />
          <TeamMember data={MemberList.TWO} />
          <TeamMember data={MemberList.THREE} />
          <TeamMember data={MemberList.FOUR} />
          <TeamMember data={MemberList.FIVE} />
          <TeamMember data={MemberList.SIX} />
          <TeamMember data={MemberList.SEVEN} />
        </div>
      </div>
    </div>
  );
};

export default OurTeams;

export const TeamMember = ({ data }) => {
  const { name, designation, desc, pic, bgColor, cls, lnURL } = data;
  const [show, setShow] = useState(false);
  const handleSeeMore = (e) => {
    // console.log("inside handleSeeMore", e);
    if (e.target !== e.currentTarget) {
      // console.log('child element clicked');
      return;
    }
    setShow(!show);
    show
      ? (document.body.style.overflow = "auto")
      : (document.body.style.overflow = "hidden");
    // toggleSeeMore()
    
  };
  const toggleSeeMore = () => {
    setShow(!show);
    show
      ? (document.body.style.overflow = "auto")
      : (document.body.style.overflow = "hidden");
  }

  useEffect(() => {
    document.body.style.overflow = "auto";
  }, []);





  return (
    <div className="teamMember p-1 p-md-2" style={{ backgroundColor: bgColor }}>
      <img src={pic} alt={`${name} pic`} />
      <div className="text-center mt-2">
        <strong className="text-center">{name}</strong>
        <a href={lnURL} target="_blank" rel="noreferrer noopener">
          <img
            className="img img-fluid teamMember-linkedin ps-2"
            src={linkedin}
            alt={`${name} LinkedIn Profile`}
          />
        </a>
      </div>
      <p className="designation text-center">{designation}</p>
      <p className="text-center short-desc mt-2">{desc}</p>
      <span className="seeMore" onClick={handleSeeMore}>
        see more
        <img src={openPopup} alt="open popup" className="openPopup" onClick={handleSeeMore}/>
      </span>
      <div 
        className={show ? "openPopupContainer" : "d-none"}
        onClick={handleSeeMore}
      >
        <OpenPopupTemplate id="X" data={data} toggleSeeMore={toggleSeeMore} />
      </div>
    </div>
  );
};

const OpenPopupTemplate = ({ data, toggleSeeMore }) => {
  const { name, designation, desc, pic, bgColor, cls, lnURL } = data;

  return (
    <div className="teamMember-expand" name="teamMember-expand-container">
      <img src={pic} alt={`${name} pic`} />
      <div className="name_linkedin mt-2">
        <h3 className="m-0">{name}</h3>
        <a href={lnURL} target="_blank" rel="noreferrer noopener">
          <img
            className="img img-fluid teamMember-linkedin ps-2"
            src={linkedin}
            alt={`${name} LinkedIn Profile`}
          />
        </a>
      </div>
      <p className="designation">{designation}</p>
      <p className="fullDesc mt-3">{desc}</p>
      <div className="quiteContainer" onClick={toggleSeeMore}>
        <img src={closeIcon} alt="closed-icon" />
      </div>
    </div>
  );
};

const MemberList = {
  ONE: {
    name: "Abhimanu Kumar",
    desc: [
      "Abhi has extensive expertise in Machine Learning and AI and has authored/co-authored multiple",
      <a
        href="https://scholar.google.com/citations?user=6HgpyjMAAAAJ&hl=en&utm_source=CausalFunnel"
        target="_blank"
      >
        {" "}
        well cited publications{" "}
      </a>,
      " in many of their subfields. He is a member of the Fast Company Executive Board - invited for his industry expertise. In the past, he has been a Greatness Awardee at Microsoft Ads Team (2021), and also led the Machine Learning team at GageIn to CODiE Awards Finals (2015). He has also worked as Sr. Data Scientist at Apple and Groupon, and on the Wall Street as a Quant Trader at IMC Financial Markets. Abhi has a bachelors degree in Computer Science from IIT and graduate degrees from CMU and UT Austin and was also admitted to MIT for a PhD.",
    ],
    pic: AbhimanuKumar,
    designation: "Co-Founder & CEO",
    // bgColor: "#FFDDED",
    bgColor: "#ebfbff",
    cls: "teamMember-picRight",
    lnURL:
      "https://www.linkedin.com/in/abhimanu-kumar/?utm_source=CausalFunnel",
  },
  TWO: {
    name: "Brian Bohus",
    desc: "Brian is the Growth Leader for CausalFunnel. He has 10+ years in growing sales teams and has sold millions of dollars in annual revenue. Brian started out selling services in the expense management consulting sector before learning tech and getting into tech sales. He now handles the growth for CausalFunnel Platform for new businesses.",
    pic: BrianBohus,
    designation: "Growth Leader",
    // bgColor: "#FFEEB0",
    bgColor: "#ebfbff",
    cls: "",
    lnURL:
      "https://www.linkedin.com/in/brian-bohus-15386265/?utm_source=CausalFunnel",
  },
  THREE: {
    name: "Jeetu Mahtani",
    desc: "Jeetu Mahtani is the Executive Vice President of Customer Success at HubSpot, where he is responsible for the vision and execution of customer service and support of HubSpot’s global customer base. Prior to his role as EVP, Jeetu served as HubSpot's Senior Vice President of Sales and Managing Director of International Operations driving HubSpot's growth around the world. Jeetu founded the search marketing and lead generation practice at a marketing agency in the Boston area and grew the business to one of the fastest-growing marketing agencies in the region. As a former consultant in the SAP CRM space, Jeetu lived and worked in several countries including the US, Ireland, France, Hong Kong and India.",
    pic: JeetuMahtani,
    designation: "Investor & Advisor",
    // bgColor: "#bfe0d1",
    bgColor: "#ebfbff",
    cls: "",
    lnURL: "https://www.linkedin.com/in/jeetumahtani/?utm_source=CausalFunnel",
  },
  FOUR: {
    name: "Kieran Flanagan",
    desc: "Kieran Flanagan is CMO at Zapier. Prior to his role as CMO, Kieran served as SVP Marketing at HubSpot. He has expertise in helping SaaS companies adding millions in extra traffic, users, and revenue.",
    pic: KieranFlanagan,
    designation: "Investor & Advisor",
    // bgColor: "#f5dfd7",
    bgColor: "#ebfbff",
    cls: "",
    lnURL:
      "https://www.linkedin.com/in/kieranjflanagan?utm_source=CausalFunnel",
  },
  FIVE: {
    name: "John Kelleher",
    desc: "John Kelleher is General Counsel for Dutchie. Prior to his role at Dutchie, Kieran served as SVP and General Counsel at Hubspot, Endeca Technologies. ",
    pic: JohnKelleher,
    designation: "Investor & Advisor",
    bgColor: "#ebfbff",
    cls: "",
    lnURL:
      "https://www.linkedin.com/in/jokelleher/?utm_source=CausalFunnel",
  },
  SIX: {
    name: "Alok Ranjan",
    desc: [
      "A New Media innovator, Founder & CEO of Future Today Inc which owns the most popular channels on OTT devices and connected TV including Happykids.tv, iFood.tv, Fawesome.tv, iComedy.tv, TripSmart, FitYou, and many more.",
      <a
        href="https://www.nytimes.com/2012/09/23/jobs/Alok-Ranjan-of-ifoodtv-on-conquering-the-kitchen.html"
        target="_blank"
      >
        {" "}
        Times Profile
      </a>,
      ".",
    ],
    pic: AlokRanjan,
    designation: "Investor & Advisor",
    // bgColor: "#cbebf0",
    bgColor: "#ebfbff",
    cls: "",
    lnURL: "https://www.linkedin.com/in/alokranjan/?utm_source=CausalFunnel",
  },
  SEVEN: {
    name: "Vagelis Papalexakis",
    desc: [
      "Associate Professor at the Computer Science & Engineering Department at the University of California Riverside. A leading researcher in the world, working on data mining, machine learning, and data science.",
      <br />,
      <a href="https://www.cs.ucr.edu/~epapalex/" target="_blank">
        {" "}
        University of California Riverside
      </a>,
      ".",
    ],
    pic: VagelisPapalexakis,
    designation: "Advisor",
    // bgColor: "#eedbf9",
    bgColor: "#ebfbff",
    cls: "",
    lnURL:
      "https://www.linkedin.com/in/vagelispapalexakis/?utm_source=CausalFunnel",
  },

};
